export const politics = [
    {
        id: "content-politics-what-really-matters",
        name: "What Really Matters",
        articles: [
            {
                id: "5fed924d-8356-4d2e-bf06-ba58866f4cd0",
                class: "columns-1",
                type: "grid",
                display: "grid-wrap",
                content: [
                    {
                        id: "0e4a3d8c-a290-4921-9067-0c6f06f318f6",
                        image: {
                            src: "assets/images/emmanuel-ikwuegbu-ceawFbpA-14-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Libero justo laoreet sit amet. Et egestas quis ipsum suspendisse ultrices gravida dictum fusce. Eget aliquet nibh praesent tristique magna. Turpis cursus in hac habitasse platea dictumst quisque sagittis purus.",
                        url: "#",
                    },
                    {
                        id: "b5487ca6-95b7-4dc9-a96b-127ba70c1601",
                        image: {
                            src: "assets/images/mr-cup-fabien-barral-Mwuod2cm8g4-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Arcu cursus euismod quis viverra nibh. Cras ornare arcu dui vivamus arcu. At lectus urna duis convallis convallis tellus id.",
                        url: "#",
                    },
                    {
                        id: "6eb4edcf-6a84-4997-b053-f63bf6757f24",
                        image: {
                            src: "assets/images/colin-lloyd-uaM_Ijy_joY-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Urna et pharetra pharetra massa massa ultricies mi quis hendrerit. Risus sed vulputate odio ut enim blandit volutpat maecenas volutpat. Quis ipsum suspendisse ultrices gravida dictum fusce ut.",
                        url: "#",
                    },
                    {
                        id: "a0fd29d4-8eaa-470b-9f6e-5ee20680cba9",
                        image: {
                            src: "assets/images/sara-cottle-bGjtWs8sXT0-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Velit aliquet sagittis id consectetur purus ut faucibus. Tellus mauris a diam maecenas sed. Urna neque viverra justo nec. Odio eu feugiat pretium nibh ipsum.",
                        url: "#",
                    },
                    {
                        id: "c46c8374-58d9-4e4d-b67c-2722031478d8",
                        image: {
                            src: "assets/images/elimende-inagella-7OxV_qDiGRI-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Amet nulla facilisi morbi tempus iaculis urna id. Scelerisque eleifend donec pretium vulputate sapien nec sagittis. Id leo in vitae turpis massa.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-today",
        name: "Today",
        articles: [
            {
                id: "88787560-ed1b-43d5-a57c-bac38c8af902",
                class: "columns-3-wide",
                header: "Campaign News",
                url: "#",
                image: {
                    src: "assets/images/alexander-grey-8lnbXtxFGZw-unsplash_684.jpg",
                    alt: "Placeholder",
                    width: "684",
                    height: "385",
                },
                meta: {
                    captions: "Photo taken by someone.",
                    tag: {
                        type: "breaking",
                        label: "breaking",
                    },
                },
                title: "Adipiscing at in tellus integer feugiat scelerisque varius morbi enim.",
                type: "list",
                content: [
                    {
                        id: "b1c84fd6-18ac-4043-83c6-d17da3be2838",
                        content: "Sem fringilla ut morbi tincidunt augue interdum velit euismod.",
                    },
                    {
                        id: "f817229a-1567-4892-955f-076d736c2e40",
                        content: "Quisque sagittis purus sit amet. Ornare lectus sit amet est.",
                    },
                    {
                        id: "44719b28-a2bb-49d1-8391-cd79e8cd74cf",
                        content: "Placerat orci nulla pellentesque dignissim enim sit amet.",
                    },
                    {
                        id: "9d4e196a-50a8-45b1-9d13-0594b4728ce9",
                        content: "In fermentum et sollicitudin ac orci phasellus egestas tellus.",
                    },
                ],
            },
            {
                id: "8eeaee25-a813-430f-9f1e-00ac72d6e0f9",
                class: "columns-3-narrow",
                header: "Elections",
                url: "#",
                type: "preview",
                content: [
                    {
                        id: "ca84a215-8a32-4591-bb30-18935c91d919",
                        image: {
                            src: "assets/images/red-dot-Q98X_JVRGS0-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Nunc aliquet bibendum enim facilisis gravida neque. Nec feugiat in fermentum posuere urna. Molestie at elementum eu facilisis sed odio morbi. Scelerisque purus semper eget duis at tellus.",
                    },
                    {
                        id: "6016d07f-159b-4bc2-91a1-0009502693e8",
                        image: {
                            src: "assets/images/parker-johnson-v0OWc_skg0g-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Eget dolor morbi non arcu risus quis. Non curabitur gravida arcu ac tortor dignissim.",
                    },
                ],
            },
            {
                id: "f56f95e8-6db3-4fb3-9797-be9e6e8713d1",
                class: "columns-3-narrow",
                header: "Local Government",
                url: "#",
                image: {
                    src: "assets/images/valery-tenevoy-c0VbjkPEfmM-unsplash_336.jpg",
                    alt: "Placeholder",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Nunc vel risus commodo viverra maecenas accumsan lacus.",
                type: "list",
                content: [
                    {
                        id: "fad4a569-d337-4885-af2e-3da36e7444b3",
                        content: "Molestie at elementum eu facilisis sed odio morbi.",
                    },
                    {
                        id: "64208fee-49d3-4536-863c-7a03741acd62",
                        content: "Sit amet nisl suscipit adipiscing bibendum est ultricies integer quis.",
                    },
                    {
                        id: "f28139dc-e8b6-4d3b-86ad-8ef8ed5f6828",
                        content: "Bibendum neque egestas congue quisque egestas diam in arcu.",
                    },
                    {
                        id: "9e7e7929-ac40-4a14-bf41-467af7bc2bbc",
                        content: "Tellus molestie nunc non blandit massa enim nec.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-latest-headlines",
        name: "Latest Headlines",
        articles: [
            {
                id: "a497dc76-3124-4e34-a562-393b3ed0a2d0",
                class: "columns-3-balanced",
                header: "Analysis",
                image: {
                    src: "assets/images/scott-graham-OQMZwNd3ThU-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Pellentesque pulvinar pellentesque habitant morbi tristique senectus et netus et.",
                type: "list",
                content: [
                    {
                        id: "9709aba3-dea5-4634-af0d-a0272373fc91",
                        content: "Arcu vitae elementum curabitur vitae nunc sed velit.",
                    },
                    {
                        id: "56b038d5-ae4d-4eb0-a24f-eadd6e933311",
                        content: "Ornare suspendisse sed nisi lacus sed viverra tellus in.",
                    },
                    {
                        id: "74f5f5fa-d5cf-4854-a52b-7d267ba01da6",
                        content: "Vel fringilla est ullamcorper eget nulla.",
                    },
                    {
                        id: "585db761-3e2b-4789-9e7f-3e8a3ab70aae",
                        content: "Risus commodo viverra maecenas accumsan lacus vel facilisis volutpat est.",
                    },
                ],
            },
            {
                id: "3b2ff2f5-1aa4-471d-afe4-4134e7239b3a",
                class: "columns-3-balanced",
                header: "Facts First",
                image: {
                    src: "assets/images/campaign-creators-pypeCEaJeZY-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "At varius vel pharetra vel turpis nunc eget lorem dolor.",
                type: "list",
                content: [
                    {
                        id: "b6d3d1d2-9ef8-48a2-8463-07eb4cd0757c",
                        content: "Consectetur purus ut faucibus pulvinar elementum integer enim.",
                    },
                    {
                        id: "53572fab-f3f1-4c47-ab93-b2896352265a",
                        content: "Purus semper eget duis at. Tincidunt ornare massa eget egestas purus viverra accumsan.",
                    },
                    {
                        id: "528626d6-5909-42a3-a4a1-b406ac06c673",
                        content: "Amet massa vitae tortor condimentum lacinia quis vel.",
                    },
                    {
                        id: "6d3ce580-c7a6-4bf7-b93a-e012e21f6037",
                        content: "Tristique senectus et netus et malesuada.",
                    },
                ],
            },
            {
                id: "d3f0d391-b7ad-4421-a6d2-7d004a21d6d9",
                class: "columns-3-balanced",
                header: "More Politics News",
                image: {
                    src: "assets/images/priscilla-du-preez-GgtxccOjIXE-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Vitae auctor eu augue ut lectus arcu bibendum at varius.",
                type: "text",
                content:
                    "Pharetra diam sit amet nisl suscipit adipiscing bibendum est. Id aliquet lectus proin nibh. Porta lorem mollis aliquam ut porttitor leo a. Congue eu consequat ac felis donec et odio pellentesque.\n\nMi ipsum faucibus vitae aliquet nec ullamcorper. Sapien nec sagittis aliquam malesuada bibendum arcu vitae elementum curabitur. Quis imperdiet massa tincidunt nunc pulvinar sapien et ligula ullamcorper.",
            },
        ],
    },
    {
        id: "content-politics-latest-media",
        name: "Latest Media",
        articles: [
            {
                id: "db2737cd-27a6-479d-a387-ad8009ede603",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "8879d7ec-ecde-4a40-b463-eaf0beb033db",
                        image: {
                            src: "assets/images/ruben-valenzuela-JEp9cl5jfZA-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "ff8f1fca-f830-4450-a946-075f95f37569",
                        image: {
                            src: "assets/images/gregory-hayes-h5cd51KXmRQ-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "ea8500ef-7130-40ef-bb35-a9e5fc6506b6",
                        image: {
                            src: "assets/images/alan-rodriguez-qrD-g7oc9is-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "6481e63a-f2ab-42d3-9c99-cc22cebb3207",
                        image: {
                            src: "assets/images/redd-f-N9CYH-H_gBE-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-election",
        name: "Election",
        articles: [
            {
                id: "29de4b05-b033-4382-9b05-cd4ad886f497",
                class: "columns-wrap",
                header: "Democrats",
                type: "excerpt",
                content: [
                    {
                        id: "c691231f-64bb-4710-bfbf-f4e60fc71457",
                        image: {
                            src: "assets/images/dyana-wing-so-Og16Foo-pd8-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Est ullamcorper eget nulla facilisi etiam dignissim. Est pellentesque elit ullamcorper dignissim cras. Velit euismod in pellentesque massa placerat duis ultricies.",
                    },
                    {
                        id: "0c01ee2b-971a-427d-aa7c-02090f28b5d2",
                        image: {
                            src: "assets/images/colin-lloyd-NKS5gg7rWGw-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Vitae suscipit tellus mauris a diam maecenas sed enim. Aenean sed adipiscing diam donec. Laoreet suspendisse interdum consectetur libero id faucibus nisl tincidunt.",
                    },
                    {
                        id: "3917e92e-a5db-4c9f-8c2a-42c0bc8f39fe",
                        image: {
                            src: "assets/images/jon-tyson-0BLE1xp5HBQ-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Mattis enim ut tellus elementum sagittis vitae et. Massa sapien faucibus et molestie.",
                    },
                ],
            },
            {
                id: "54a12e98-d00c-455d-b806-98594181ce1e",
                class: "columns-wrap",
                header: "Republicans",
                type: "excerpt",
                content: [
                    {
                        id: "7ef5a8ae-55ba-4c4e-b80d-ed02cc2a51db",
                        image: {
                            src: "assets/images/clay-banks-BY-R0UNRE7w-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Platea dictumst quisque sagittis purus sit amet volutpat. Ante in nibh mauris cursus mattis molestie a iaculis.",
                    },
                    {
                        id: "57870f0d-6a22-4648-b1fa-66bed5b14f51",
                        image: {
                            src: "assets/images/kelly-sikkema-A-lovieAmjA-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Quis hendrerit dolor magna eget est. Pellentesque pulvinar pellentesque habitant morbi tristique. Adipiscing commodo elit at imperdiet dui.",
                    },
                    {
                        id: "7c362a1f-12d0-4aa4-9bf9-490ea6d0ff10",
                        image: {
                            src: "assets/images/chad-stembridge-sEHrIPpkKQY-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Donec pretium vulputate sapien nec sagittis aliquam. Cras adipiscing enim eu turpis egestas pretium aenean.",
                    },
                ],
            },
            {
                id: "8ad5e658-cfe7-42d1-8e28-764010c5b34f",
                class: "columns-wrap",
                header: "Liberals",
                type: "excerpt",
                content: [
                    {
                        id: "3c3f4a8c-3b1c-4095-8030-cf45219e5032",
                        image: {
                            src: "assets/images/derick-mckinney-muhK4oeYJiU-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Cursus sit amet dictum sit amet justo donec enim. Tempor id eu nisl nunc. Amet cursus sit amet dictum sit amet justo donec.",
                    },
                    {
                        id: "2b882425-c070-46ec-87b8-4fbd5afdf105",
                        image: {
                            src: "assets/images/marek-studzinski-9U9I-eVx9nI-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Enim diam vulputate ut pharetra sit amet aliquam. Tristique senectus et netus et malesuada.",
                    },
                    {
                        id: "5ff98d91-9d27-4638-b093-35118ec4c4f0",
                        image: {
                            src: "assets/images/2h-media-lPcQhLP-b4I-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Eu turpis egestas pretium aenean. Auctor elit sed vulputate mi sit amet. In nibh mauris cursus mattis molestie.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-more-political-news",
        name: "More political News",
        articles: [
            {
                id: "ba31d7b5-0a2b-421d-880b-83cbf0503a45",
                class: "columns-3-wide",
                header: "More News",
                url: "#",
                type: "list",
                content: [
                    {
                        id: "db6b9420-b409-4cc8-8301-aebdd4a61546",
                        content: "Eros donec ac odio tempor. Tortor pretium viverra suspendisse potenti nullam.",
                    },
                    {
                        id: "8b43439d-58be-46b1-9e80-4ed4509ecb55",
                        content: "Ut venenatis tellus in metus vulputate eu scelerisque.",
                    },
                    {
                        id: "f20bc1e5-8744-4750-ac7f-8f8ad64a8726",
                        content: "Id diam maecenas ultricies mi eget. Nisl nunc mi ipsum faucibus vitae aliquet nec ullamcorper sit.",
                    },
                    {
                        id: "82ed67d9-e0d8-471b-8f7d-2d23d7122593",
                        content: "Consectetur lorem donec massa sapien. Sed cras ornare arcu dui vivamus arcu felis.",
                    },
                    {
                        id: "7b58754b-9115-4005-a4b5-3d0841f6918a",
                        content: "Fames ac turpis egestas maecenas pharetra convallis posuere morbi.",
                    },
                    {
                        id: "75ad2be4-2ae6-40b7-b99f-7760277897a3",
                        content: "Consequat nisl vel pretium lectus quam id.",
                    },
                    {
                        id: "d18452c7-823c-499e-b67e-490398fa1f54",
                        content: "Tincidunt ornare massa eget egestas purus viverra accumsan in nisl.",
                    },
                    {
                        id: "7e56b434-d474-4cc3-ac87-becc642e351c",
                        content: "Sed euismod nisi porta lorem mollis aliquam ut.",
                    },
                    {
                        id: "b0c333a5-7eb4-4142-9141-28cf317adaba",
                        content: "Suspendisse sed nisi lacus sed viverra tellus in hac.",
                    },
                    {
                        id: "1895e527-3dda-4280-8158-62f2214d30ec",
                        content: "Aliquet risus feugiat in ante metus dictum at tempor.",
                    },
                    {
                        id: "0198d35a-5253-4a93-9af8-22d2169b88d7",
                        content: "Velit aliquet sagittis id consectetur purus ut faucibus.",
                    },
                    {
                        id: "e4143447-b828-4b32-8d96-df8fd84763c0",
                        content: "Libero volutpat sed cras ornare. Consectetur adipiscing elit duis tristique sollicitudin nibh sit amet.",
                    },
                    {
                        id: "89e179d9-7127-4937-a022-f20b81357679",
                        content: "Nibh nisl condimentum id venenatis a condimentum vitae. Fames ac turpis egestas maecenas pharetra.",
                    },
                    {
                        id: "aff19a6f-a89e-4e4f-bd2c-5291dd95dc9b",
                        content: "Massa sapien faucibus et molestie. Ac turpis egestas maecenas pharetra convallis posuere morbi leo urna.",
                    },
                    {
                        id: "a9ce2ec0-2235-46ab-ade2-7fd808ca3de9",
                        content: "Est pellentesque elit ullamcorper dignissim cras. Mi proin sed libero enim sed.",
                    },
                ],
            },
            {
                id: "1900eb3e-e44a-481b-abe7-d82aafb5a4ed",
                class: "columns-3-narrow",
                url: "#",
                type: "preview",
                content: [
                    {
                        id: "cf0c05c6-a132-40af-b462-1928ed5299b1",
                        image: {
                            src: "assets/images/vanilla-bear-films-JEwNQerg3Hs-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Nunc aliquet bibendum enim facilisis gravida neque. Nec feugiat in fermentum posuere urna. Molestie at elementum eu facilisis sed odio morbi. Scelerisque purus semper eget duis at tellus.",
                    },
                    {
                        id: "e1d1d173-a259-4091-baea-60c3366fd879",
                        image: {
                            src: "assets/images/dani-navarro-6CnGzrLwM28-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Eget dolor morbi non arcu risus quis. Non curabitur gravida arcu ac tortor dignissim.",
                    },
                    {
                        id: "fbfdf20e-f6e3-404b-b7be-8d9c64d5f0cc",
                        image: {
                            src: "assets/images/wan-san-yip-ID1yWa1Wpx0-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Eget dolor morbi non arcu risus quis. Non curabitur gravida arcu ac tortor dignissim.",
                    },
                ],
            },
            {
                id: "212ae8c8-9689-4c4c-b75c-6af97924c561",
                class: "columns-3-narrow",
                url: "#",
                type: "preview",
                content: [
                    {
                        id: "5e31f22f-30d5-4d88-97ce-9584a378911e",
                        image: {
                            src: "assets/images/david-beale--lQR8yeDzek-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Tellus in metus vulputate eu scelerisque felis imperdiet proin fermentum.",
                    },
                    {
                        id: "55c34060-7e3d-40a8-9a31-20a15bbed649",
                        image: {
                            src: "assets/images/arnaud-jaegers-IBWJsMObnnU-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Adipiscing tristique risus nec feugiat in fermentum posuere vulputate eu scelerisque.",
                    },
                    {
                        id: "8b96fd4c-1648-4a3c-96a5-c0ac52d02b60",
                        image: {
                            src: "assets/images/kevin-rajaram-qhixFFO8EWQ-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Potenti nullam ac tortor vitae purus. Adipiscing diam donec adipiscing tristique risus nec feugiat in fermentum.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-underscored",
        name: "Underscored",
        articles: [
            {
                id: "78fb02c4-4a19-4c24-a504-fb029810730e",
                class: "columns-2-balanced",
                header: "This First",
                type: "grid",
                content: [
                    {
                        id: "c3bd82d1-a2d7-4f10-ac62-e3c6f8812b55",
                        image: {
                            src: "assets/images/kyle-glenn-gcw_WWu_uBQ-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Ut aliquam purus sit amet luctus venenatis lectus magna fringilla. Urna neque viverra justo nec ultrices dui sapien. Egestas sed sed risus pretium quam vulputate dignissim suspendisse. Risus viverra adipiscing at in tellus integer feugiat scelerisque. Pretium nibh ipsum consequat nisl vel.",
                        url: "#",
                    },
                    {
                        id: "1405735c-c7e6-4531-ad8c-d4c158960c2e",
                        image: {
                            src: "assets/images/toa-heftiba-4xe-yVFJCvw-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Nunc id cursus metus aliquam eleifend. Sit amet est placerat in egestas erat. Vitae tortor condimentum lacinia quis vel eros donec ac. Maecenas pharetra convallis posuere morbi leo urna molestie at. Lectus proin nibh nisl condimentum id venenatis. Ut enim blandit volutpat maecenas volutpat blandit.",
                        url: "#",
                    },
                ],
            },
            {
                id: "c215acac-4b82-4696-a5d7-a33f322c45f3",
                class: "columns-2-balanced",
                header: "This Second",
                type: "grid",
                content: [
                    {
                        id: "d7f4ffb0-9dfe-45c5-85cf-bed1b25741bd",
                        image: {
                            src: "assets/images/harri-kuokkanen-SEtUeWL8bIQ-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Vestibulum sed arcu non odio euismod lacinia. Ipsum dolor sit amet consectetur. Nisi scelerisque eu ultrices vitae. Eu consequat ac felis donec. Viverra orci sagittis eu volutpat odio facilisis mauris sit amet. Purus semper eget duis at tellus at urna. Nulla aliquet porttitor lacus luctus accumsan tortor posuere ac.",
                        url: "#",
                    },
                    {
                        id: "4ba86b88-39b7-44fd-bf9f-fc2bfc225281",
                        image: {
                            src: "assets/images/ednilson-cardoso-dos-santos-haiooWA_weo-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Elementum eu facilisis sed odio morbi. Scelerisque viverra mauris in aliquam sem fringilla ut. Enim ut sem viverra aliquet. Massa sed elementum tempus egestas. Nam at lectus urna duis convallis convallis tellus. Sem integer vitae justo eget magna. In mollis nunc sed id.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-trending",
        name: "Trending",
        articles: [
            {
                id: "40fc21b9-2db4-47e2-96ef-2d95e79a9df3",
                class: "columns-wrap",
                header: "New Legislations",
                type: "excerpt",
                content: [
                    {
                        id: "75d1b551-a1cc-4548-aa28-f1d493c5925f",
                        image: {
                            src: "assets/images/markus-spiske-7PMGUqYQpYc-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Consequat ac felis donec et. Libero nunc consequat interdum varius sit amet mattis vulputate enim. Cursus euismod quis viverra nibh cras pulvinar mattis nunc. Nisi lacus sed viverra tellus in hac. Aliquam malesuada bibendum arcu vitae elementum curabitur.",
                    },
                    {
                        id: "2d4876f9-45be-4aa9-8ac7-56232b55d649",
                        image: {
                            src: "assets/images/viktor-talashuk-05HLFQu8bFw-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Neque gravida in fermentum et sollicitudin ac orci. Pretium aenean pharetra magna ac placerat vestibulum lectus mauris ultrices. Fermentum leo vel orci porta non pulvinar neque laoreet.",
                    },
                    {
                        id: "a1e61b50-4106-4f68-9f35-822452c473bd",
                        image: {
                            src: "assets/images/anastassia-anufrieva-ecHGTPfjNfA-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Egestas diam in arcu cursus. Aliquam eleifend mi in nulla posuere sollicitudin aliquam ultrices sagittis. Augue ut lectus arcu bibendum at varius vel pharetra.",
                    },
                ],
            },
            {
                id: "9f10b36d-0666-479c-a234-a7ab95f9737d",
                class: "columns-wrap",
                header: "Latest Polls",
                type: "excerpt",
                content: [
                    {
                        id: "174f4a54-5f05-499b-8255-9dce7caccff3",
                        image: {
                            src: "assets/images/bianca-ackermann-qr0-lKAOZSk-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Aliquam eleifend mi in nulla posuere sollicitudin. Tempor nec feugiat nisl pretium fusce. Fermentum iaculis eu non diam phasellus vestibulum lorem. Scelerisque eleifend donec pretium vulputate sapien nec. Sit amet aliquam id diam maecenas ultricies mi.",
                    },
                    {
                        id: "b5b69901-c646-4034-9f11-d54357ea745b",
                        image: {
                            src: "assets/images/phil-hearing-bu27Y0xg7dk-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Morbi leo urna molestie at elementum eu. Phasellus vestibulum lorem sed risus. Aliquet bibendum enim facilisis gravida neque. Aliquam sem et tortor consequat id porta. Interdum varius sit amet mattis vulputate enim nulla aliquet. Enim nulla aliquet porttitor lacus luctus accumsan tortor.",
                    },
                    {
                        id: "9cd2a3f7-3723-4295-af72-fbbfa4a232d2",
                        image: {
                            src: "assets/images/mika-baumeister-Hm4zYX-BDxk-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Molestie nunc non blandit massa. Adipiscing diam donec adipiscing tristique risus nec feugiat in. Odio morbi quis commodo odio aenean sed adipiscing diam donec. Felis eget velit aliquet sagittis id consectetur purus ut. Odio ut enim blandit volutpat maecenas.",
                    },
                ],
            },
            {
                id: "d86ca00e-4e84-48ac-8c95-118d7c9a2e44",
                class: "columns-wrap",
                header: "Who's gaining votes",
                type: "excerpt",
                content: [
                    {
                        id: "6c3745c6-3dc4-435f-b81a-8d2b06cc1ad2",
                        image: {
                            src: "assets/images/wesley-tingey-7BkCRNwh_V0-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Risus viverra adipiscing at in tellus integer feugiat scelerisque. Porttitor eget dolor morbi non arcu risus quis varius quam. Consectetur adipiscing elit ut aliquam purus sit. Pulvinar mattis nunc sed blandit.",
                    },
                    {
                        id: "32de17cf-8c35-4ad0-99e2-3328c80c296e",
                        image: {
                            src: "assets/images/miguel-bruna-TzVN0xQhWaQ-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Non curabitur gravida arcu ac tortor dignissim. Purus in mollis nunc sed id semper risus in hendrerit. Vestibulum morbi blandit cursus risus. Pellentesque nec nam aliquam sem et tortor. Ac tortor dignissim convallis aenean et.",
                    },
                    {
                        id: "bb64bf13-a35b-4dad-99bf-810f67772471",
                        image: {
                            src: "assets/images/clay-banks-cisdc-344vo-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Ullamcorper a lacus vestibulum sed arcu non. Pharetra sit amet aliquam id diam. Viverra vitae congue eu consequat ac felis donec. Amet massa vitae tortor condimentum lacinia quis vel eros.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-around-the-world",
        name: "Around the World",
        articles: [
            {
                id: "d7923d94-7cd8-418a-865e-2b90faf6f830",
                class: "columns-3-balanced",
                header: "Britain",
                image: {
                    src: "assets/images/marc-olivier-jodoin-_eclsGKsUdo-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Sed blandit libero volutpat sed cras ornare arcu dui. Id ornare arcu odio ut sem.",
                type: "list",
                content: [
                    {
                        id: "a2341f46-19cf-4723-9568-d77b410ba8c4",
                        content: "Dolor sed viverra ipsum nunc aliquet bibendum enim. Hendrerit dolor magna eget est lorem ipsum dolor.",
                    },
                    {
                        id: "73423726-07db-4616-8c7d-17f68481245f",
                        content: "At elementum eu facilisis sed odio morbi quis commodo odio. In massa tempor nec feugiat nisl.",
                    },
                    {
                        id: "f897bb1f-53b8-4e47-a367-d78562e9ee93",
                        content: "Est sit amet facilisis magna etiam tempor orci eu. Vulputate dignissim suspendisse in est ante in.",
                    },
                    {
                        id: "bc5de5a0-d46c-43ce-bdec-5ef55c6cdeb2",
                        content: "Tempor nec feugiat nisl pretium. Id velit ut tortor pretium viverra suspendisse potenti nullam.",
                    },
                ],
            },
            {
                id: "f87a7154-8143-4c09-8afe-96f965e00089",
                class: "columns-3-balanced",
                header: "Italy",
                image: {
                    src: "assets/images/sandip-roy-4hgTlYb9jzg-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Vitae congue mauris rhoncus aenean vel elit.",
                type: "list",
                content: [
                    {
                        id: "ffcb5b5e-a2c1-4066-b807-a62699df06b7",
                        content: "Aliquam sem fringilla ut morbi tincidunt augue interdum. Enim eu turpis egestas pretium aenean pharetra magna ac.",
                    },
                    {
                        id: "bd5a8aa1-fc84-4882-afdb-efa33d02fc12",
                        content: "Amet porttitor eget dolor morbi non arcu risus quis varius. Ultricies tristique nulla aliquet enim tortor at auctor.",
                    },
                    {
                        id: "f5badbd1-d614-44a0-85c9-7f1e6a5f1bcf",
                        content: "Nisi lacus sed viverra tellus in hac habitasse platea. Interdum velit euismod in pellentesque.",
                    },
                    {
                        id: "420e0800-ef7e-45ee-9bba-d7b44cef4b69",
                        content: "Mattis ullamcorper velit sed ullamcorper morbi tincidunt ornare. Eu non diam phasellus vestibulum lorem sed risus.",
                    },
                ],
            },
            {
                id: "14d07dfb-3587-4411-b4ce-33ba171152f4",
                class: "columns-3-balanced",
                header: "Poland",
                image: {
                    src: "assets/images/maksym-harbar-okn8ZIjPMxI-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Sed id semper risus in hendrerit gravida rutrum quisque.",
                type: "list",
                content: [
                    {
                        id: "4611e3bf-0274-408d-a019-c6688e600dd8",
                        content: "Viverra justo nec ultrices dui sapien eget. A scelerisque purus semper eget duis at tellus at.",
                    },
                    {
                        id: "cfe0b6d6-ec48-4571-9bf2-97f26027f80f",
                        content: "Non diam phasellus vestibulum lorem sed risus ultricies tristique. Ornare arcu dui vivamus arcu felis bibendum ut tristique et.",
                    },
                    {
                        id: "a2415445-ab69-445b-9f27-b7b01e432302",
                        content: "Quisque non tellus orci ac. At augue eget arcu dictum varius.",
                    },
                    {
                        id: "08228c09-8678-4e3e-a256-8f528237c9d8",
                        content: "Aenean sed adipiscing diam donec adipiscing tristique. Sagittis eu volutpat odio facilisis mauris.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-hot-topics",
        name: "Hot Topics",
        articles: [
            {
                id: "df191197-ddb0-4c59-978c-560e60e62e0a",
                class: "columns-2-balanced",
                header: "This First",
                type: "grid",
                content: [
                    {
                        id: "e9d797f7-36d7-4dbe-8d2a-d6eb8f15bc07",
                        image: {
                            src: "assets/images/ronda-darby-HbMLSB-uhQY-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Suspendisse sed nisi lacus sed viverra tellus in hac habitasse. Tincidunt id aliquet risus feugiat in. Eget aliquet nibh praesent tristique magna sit amet. Enim lobortis scelerisque fermentum dui faucibus. Molestie ac feugiat sed lectus. Facilisis sed odio morbi quis commodo.",
                        url: "#",
                    },
                    {
                        id: "6b9a85a6-120d-47d6-bc5d-e6d487aedf31",
                        image: {
                            src: "assets/images/dominic-bieri-vXRt4rFr4hI-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Vitae ultricies leo integer malesuada nunc. Convallis aenean et tortor at risus viverra adipiscing at. Vitae sapien pellentesque habitant morbi tristique senectus. Pellentesque nec nam aliquam sem et tortor consequat id. Fames ac turpis egestas integer.",
                        url: "#",
                    },
                ],
            },
            {
                id: "2ba63655-af94-4da2-a4da-e7464aa070e8",
                class: "columns-2-balanced",
                header: "This Second",
                type: "grid",
                content: [
                    {
                        id: "9cb71ead-889b-492f-9b47-297ac6d97d96",
                        image: {
                            src: "assets/images/inaki-del-olmo-NIJuEQw0RKg-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Dignissim diam quis enim lobortis scelerisque fermentum dui faucibus in. Euismod quis viverra nibh cras. Non sodales neque sodales ut etiam sit. Curabitur vitae nunc sed velit dignissim sodales ut eu. Id leo in vitae turpis massa sed elementum tempus egestas.",
                        url: "#",
                    },
                    {
                        id: "7564b782-691e-494e-9ad1-5de2a2330b17",
                        image: {
                            src: "assets/images/matt-popovich-7mqsZsE6FaU-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Morbi tristique senectus et netus et malesuada fames. Placerat duis ultricies lacus sed turpis tincidunt id aliquet. Habitant morbi tristique senectus et netus et. Laoreet sit amet cursus sit amet dictum sit. Pellentesque elit ullamcorper dignissim cras tincidunt lobortis feugiat vivamus.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-politics-paid-content",
        name: "Paid Content",
        articles: [
            {
                id: "a97faeaa-1309-44ec-a9a8-dda2db1ad5f3",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "25841bbd-93a3-472b-860f-0b0af2fc8169",
                        image: {
                            src: "assets/images/maksim-larin-tecILYzVAzg-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Duis at consectetur lorem donec massa.",
                    },
                ],
            },
            {
                id: "52472e25-5e61-4bef-9aca-ac86f936d811",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "69c42fe8-a06e-4891-ae22-491f04d0a971",
                        image: {
                            src: "assets/images/evie-calder-97CO-A4P0GQ-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Eget mi proin sed libero enim sed. Proin libero nunc consequat interdum varius.",
                    },
                ],
            },
            {
                id: "a16c0da8-7dea-4cb3-af0e-0c0123bf20d3",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "2342acef-0339-444d-a23c-a33654c91665",
                        image: {
                            src: "assets/images/domino-studio-164_6wVEHfI-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Porta nibh venenatis cras sed felisDolor sit amet consectetur adipiscing elit ut aliquam purus sit.",
                    },
                ],
            },
            {
                id: "3e7d37b7-af0e-4f69-a0fd-8d0f64d2e0ba",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "3b57cdb4-8635-4be8-872e-f939538c9e56",
                        image: {
                            src: "assets/images/pat-taylor-12V36G17IbQ-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Nisl vel pretium lectus quam id leo in vitae. Ultrices neque ornare aenean euismod elementum nisi quis eleifend quam. Eget nullam non nisi est sit. Aliquet enim tortor at auctor urna.",
                    },
                ],
            },
        ],
    },
];
